import { LocalConfig } from 'common/utils';

export const customSignupFormRules = field => {
  if (LocalConfig.get('projectId') === '159') {
    if (field.component === 'PHONE') {
      return {
        ...field,
        rules: [
          ...field.rules,
          {
            behaviour: '',
            message: 'GA',
            type: 'PHONE_MASK',
          },
        ],
      };
    }
  }
  return null;
};
